import { StyledWebNavbar } from 'assets/jss/navbar-style';
import { useLocation } from 'react-router-dom';

export const WebNavbar = ({ data }) => {
  const { pathname } = useLocation();
  const hiddenPath = ['/app/report', '/app/edit'].includes(pathname) ? true : false;

  const doctorName =
    data?.firstName && data?.lastName
      ? 'دکتر' + ' ' + data?.firstName + ' ' + data?.lastName
      : '_';

  if (hiddenPath) return null;

  return (
    <StyledWebNavbar>
      <span className="nav-dr-name">{doctorName}</span>
      <div className="medical-num-text">
        <span>شماره نظام پزشکی :</span>
        <span className="medical-num">
          {!!data?.medicalNumber ? data.medicalNumber : '_'}
        </span>
      </div>
    </StyledWebNavbar>
  );
};
